module.exports = __webpack_public_path__ + "img/founder.3cae001d.jpeg";